import React, { useEffect } from "react";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import LoyaltyMangementForm from "./LoyaltyMangementForm";

const LoyaltyMangement = props => {
  const { isStore, storeId } = props;

  useEffect(() => {
    if (isStore && !storeId) {
      props.history.push("/store");
    }
  }, [isStore, storeId]);

  return (
    <>
      <PageTitle
        title={`Loyalty Management (${props.storeName})`}
        className="plr-15"
        breadCrumb={[
          {
            name: !isStore ? "sidebar.dashboard" : "sidebar.storeDashboard"
          },
          {
            name: "sidebar.loyalty"
          }
        ]}
      />
      <div className="plr-15">
        <div className="roe-card-style mtb-15">
          <div className="roe-card-header module-header">
            <div className="flex-1 fs-16 demi-bold-text">
              Loyalty Management
            </div>
          </div>
          <div className="roe-card-body">
            <LoyaltyMangementForm {...props} />
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    ...state.storeID
  };
};

export default connect(mapStateToProps, null)(LoyaltyMangement);
